<template>
  <div>
    <p class="col-lg-12 ml-2">
      Aqui você pode adicionar questões à avaliação. Após adicionadas, é
      possível alterar sua ordem de exibição e seus detalhes, bem como
      removê-las da sua avaliação. Ainda, é possível pré-visualizar a vista que
      as startups terão da sua avaliação.
    </p>
    <Container @drop="onDropQuestion($event)">
      <Draggable v-for="(question, index) in material.evaluation" :key="index">
        <card shadow type="secondary mb-3">
          <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
              <div class="col-12">
                <h3 class="mb-0">
                  <span class="column-drag-handle cursor pr-3 float-left"
                    ><i class="fas fa-bars text-gray"></i
                  ></span>
                  Questão
                  {{ index + 1 }} - {{ question.title }}
                  <span class="float-right">
                    <base-button
                      type="white"
                      size="sm"
                      class="text-primary"
                      @click="handleRemoveQuestions(index)"
                      v-tooltip.bottom="'Excluir questão'"
                    >
                      <i class="fas fa-trash text-danger"></i>
                    </base-button>
                    <base-button
                      type="white"
                      size="sm"
                      class="text-primary"
                      @click="handleOpenModalView(question, index)"
                      v-tooltip.bottom="
                        'Pré-visualizar (visualizar como startup)'
                      "
                    >
                      <i class="fas fa-eye text-primary"></i>
                    </base-button>
                    <span
                      class="ml-2"
                      v-tooltip="'Visualizar/ocultar detalhes'"
                    >
                      <i
                        class="fas fa-angle-down"
                        @click="question.showDetails = !question.showDetails"
                    /></span>
                  </span>
                </h3>
              </div>
            </div>
          </div>
          <div v-show="question.showDetails">
            <div class="row ml-lg-1">
              <div class="col-12">
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
              </div>
            </div>
            <div class="row ml-lg-2">
              <div class="col-lg-6">
                <label class="form-control-label"> Título da questão </label>
                <p>{{ question.title }}</p>
              </div>
              <div class="col-lg-6">
                <label class="form-control-label">
                  Tipo de questão
                  <i
                    class="fas fa-info-circle ml-lg-1"
                    v-tooltip="
                      'Questões de <b>múltipla escolha</b> permitem a seleção de apenas uma opção. <b>Caixas de seleção</b>, permitem a seleção de uma ou mais opções; <b>Texto</b> permite que o startup descreva sua resposta em formato de texto.'
                    "
                  ></i>
                </label>
                <p>
                  {{ questionTypes.find((e) => e.type === question.type).name }}
                </p>
              </div>
              <div class="col-lg-12" v-if="question.description">
                <label class="form-control-label">Descrição</label>
                <p>
                  {{ question.description }}
                </p>
              </div>
            </div>
            <div
              v-if="
                question.type === 'radiobox' || question.type === 'checkbox'
              "
            >
              <div class="row ml-lg-1">
                <div class="col-12">
                  <hr class="mt-3 mb-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Detalhes da questão
                  </h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <label class="form-control-label"
                    >Alternativas ({{ question.options.length }})</label
                  >
                </div>
              </div>
              <div
                class="row ml-lg-3"
                v-for="(option, aIndex) in question.options"
                :key="aIndex"
              >
                <p class="col-lg-12 mb-1 description">
                  <i class="fas fa-angle-right mr-1"></i> {{ option.title }}
                </p>
              </div>
            </div>
            <div
              v-if="
                question.type === 'checkbox' && question.right_answer.length
              "
            >
              <div class="row ml-lg-1">
                <div class="col-12">
                  <hr class="mt-3 mb-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Resposta correta
                  </h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <label class="form-control-label">
                    Alternativa(s) correta(s)
                  </label>
                </div>
              </div>
              <div class="row ml-lg-3">
                <div class="col-12">
                  <p
                    v-for="(option, oIndex) in question.options"
                    :key="oIndex"
                    class="mb-1 description"
                  >
                    <span v-if="question.right_answer[oIndex]"
                      ><i class="fas fa-angle-right mr-1"></i>
                      {{ option.title }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="
                question.type === 'radiobox' && question.right_answer.length
              "
            >
              <div class="row ml-lg-1">
                <div class="col-12">
                  <hr class="mt-3 mb-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Resposta correta
                  </h6>
                </div>
              </div>
              <div
                class="row ml-lg-2"
                v-if="question.options[question.right_answer].title"
              >
                <div class="col-lg-12">
                  <label class="form-control-label">
                    Alternativa correta
                  </label>
                </div>
              </div>
              <div class="row ml-lg-3">
                <div class="col-12">
                  <p class="mb-1 description">
                    <i class="fas fa-angle-right mr-1"></i>
                    {{ question.options[question.right_answer].title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </Draggable>
    </Container>
    <card shadow type="secondary" class="new_question">
      <div slot="header" class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-12">
            <h3 class="mb-0">
              <i class="fas fa-edit text-default mr-2" /> Nova questão
              <span class="float-right">
                <base-button
                  type="white"
                  size="sm"
                  class="text-primary"
                  @click="
                    handleOpenModalView(
                      model.questions,
                      material.evaluation.length
                    )
                  "
                  :disabled="!isValidQuestion"
                  v-tooltip.bottom="'Pré-visualizar (visualizar como startup)'"
                >
                  <i class="fas fa-eye text-primary"></i>
                </base-button>
              </span>
            </h3>
          </div>
        </div>
      </div>
      <div class="row ml-lg-1">
        <div class="col-12">
          <h6 class="heading-small text-muted mb-4">Informações básicas</h6>
        </div>
      </div>
      <div class="row ml-lg-2">
        <div class="col-lg-6">
          <base-input
            label="Título da questão*"
            v-model.trim="model.questions.title"
            placeholder="Digite o título"
          />
        </div>
        <div class="col-lg-6">
          <label class="form-control-label">
            Tipo de questão
            <i
              class="fas fa-info-circle ml-lg-1"
              v-tooltip="
                'Questões de <b>múltipla escolha</b> permitem a seleção de apenas uma opção. <b>Caixas de seleção</b>, permitem a seleção de uma ou mais opções; <b>Texto</b> permite que o startup descreva sua resposta em formato de texto.'
              "
            ></i>
          </label>
          <base-input>
            <select class="form-control" v-model="model.questions.type">
              <option selected disabled value="">
                Selecione um tipo de questão
              </option>
              <option
                v-for="type in questionTypes"
                :key="type.key"
                :value="type.type"
              >
                {{ type.name }}
              </option>
            </select>
          </base-input>
        </div>
        <div class="col-lg-12">
          <base-input label="Descrição da questão (opcional)">
            <textarea
              rows="2"
              v-model="model.questions.description"
              class="form-control"
              placeholder="Escreva aqui..."
            >
            </textarea>
          </base-input>
        </div>
      </div>
      <div
        v-if="
          model.questions.type === 'radiobox' ||
          model.questions.type === 'checkbox'
        "
      >
        <div class="row ml-lg-1">
          <div class="col-12">
            <hr class="mt-3 mb-4" />
            <h6 class="heading-small text-muted mb-4">Detalhes da questão</h6>
          </div>
        </div>
        <div class="row ml-lg-2">
          <div class="col-lg-8">
            <base-input
              label="Título da opção*"
              v-model.trim="model.option.title"
              placeholder="Digite o título"
            />
          </div>
          <div
            class="col-lg-4 text-center text-lg-left mt-lg-4 pt-lg-1 mt-0 pt-0 mb-4 mb-lg-0"
          >
            <base-button
              :disabled="!model.option.title.trim()"
              type="default"
              @click="handleAddOptions"
              ><i class="fas fa-plus mr-1"></i> Adicionar opção</base-button
            >
          </div>
        </div>
        <div class="row ml-lg-2">
          <div class="col-lg-12">
            <label class="form-control-label">
              Alternativas ({{ model.questions.options.length }})
              <i
                class="fas fa-info-circle ml-1"
                v-tooltip="
                  'Para adicionar a questão do tipo múltipla escolha ou caixas de seleção é preciso adicionar ao menos uma opção.'
                "
              ></i>
            </label>
          </div>
        </div>
        <div class="row ml-lg-2">
          <div class="col-12">
            <Container @drop="onDropOption($event)">
              <Draggable
                class="card radiobox"
                v-for="(option, index) in model.questions.options"
                :key="index"
              >
                <span class="column-drag-handle cursor pr-3 float-left"
                  ><i class="fas fa-bars text-gray"></i></span
                >{{ option.title }}
                <span class="float-right">
                  <base-button
                    type="white"
                    size="sm"
                    class="text-primary"
                    @click="handleRemoveOptions(index)"
                    v-tooltip.bottom="'Excluir opção'"
                  >
                    <i class="fas fa-trash text-danger"></i>
                  </base-button>
                </span>
              </Draggable>
            </Container>
          </div>
        </div>
        <div
          v-if="
            model.questions.type === 'radiobox' &&
            model.questions.options.length
          "
        >
          <div class="row ml-lg-1">
            <div class="col-12">
              <hr class="mt-3 mb-4" />
              <h6 class="heading-small text-muted mb-4">Resposta correta</h6>
            </div>
          </div>
          <div class="row ml-lg-2">
            <div class="col-12">
              <label class="form-control-label d-block">
                Selecione a opção correta
              </label>
              <div class="col-lg-12 mt-2 ml-lg-2">
                <base-input>
                  <base-radio
                    v-for="(option, index) in model.questions.options"
                    :key="index"
                    :name="String(index)"
                    v-model="model.questions.right_answer[0]"
                    class="mb-2 ml-2"
                    :inline="false"
                    :disabled="false"
                  >
                    <span class="ml--3">{{ option.title }}</span>
                  </base-radio>
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            model.questions.type === 'checkbox' &&
            model.questions.options.length
          "
        >
          <div class="row ml-lg-1">
            <div class="col-12">
              <hr class="mt-3 mb-4" />
              <h6 class="heading-small text-muted mb-4">Resposta correta</h6>
            </div>
          </div>
          <div class="row ml-lg-2">
            <div class="col-12">
              <label class="form-control-label">
                Selecione a(s) alternativa(s) correta(s)
              </label>
            </div>
            <div class="col-lg-12 mt-2 ml-lg-2">
              <base-input>
                <base-checkbox
                  v-for="(option, index) in model.questions.options"
                  :key="index"
                  class="mb-2 mr-1"
                  :name="String(index)"
                  v-model="model.questions.right_answer[index]"
                >
                  <span class="ml--3">{{ option.title }} </span>
                </base-checkbox>
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3 mb-3">
        <base-button
          :custom="true"
          type="default"
          :disabled="!isValidQuestion"
          @click="handleAddQuestions"
          ><i class="fas fa-plus mr-1"></i> Adicionar esta questão</base-button
        >
      </div>
    </card>
    <modal
      :show.sync="modalView.show"
      modal-classes="modal-dialog-centered modal-lg"
      body-classes="pb-0"
      header-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Visualizar questão (ponto de vista do startup)
      </h6>
      <div class="vld-parent" ref="modal_view">
        <h3>
          Questão {{ modalView.index + 1 }} -
          {{ modalView.question.title }}
        </h3>
        <p class="ml-1">{{ modalView.question.description }}</p>
        <div v-if="modalView.question.type === 'text'">
          <textarea rows="2" class="form-control" placeholder="Escreva aqui...">
          </textarea>
        </div>
        <div v-else-if="modalView.question.type === 'radiobox'">
          <div class="row ml-lg-2">
            <div class="col-lg-12">
              <base-input>
                <base-radio
                  v-for="(option, index) in modalView.question.options"
                  :key="index"
                  :name="option.title"
                  class="mb-2"
                  v-model="modalView.radioSelect[0]"
                >
                  <span class="ml--3">{{ option.title }}</span>
                </base-radio>
              </base-input>
            </div>
            <!-- <div class="col-lg-12" v-if="modalView.radioSelect.length">
              <hr class="mt-3 mb-4" />
              <div
                class="row"
                v-if="
                  modalView.question.options[modalView.question.right_answer]
                    .title
                "
              >
                <div class="col-lg-12">
                  <label class="form-control-label">
                    Alternativa correta
                  </label>
                  <p>
                    {{
                      modalView.question.options[
                        modalView.question.right_answer
                      ].title
                    }}
                  </p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div v-else-if="modalView.question.type === 'checkbox'">
          <div class="row ml-lg-2">
            <div class="col-lg-12">
              <base-checkbox
                class="mb-2 mr-1"
                v-model="modalView.checkboxSelect[index]"
                v-for="(option, index) in modalView.question.options"
                :key="index"
              >
                <span class="ml--3">{{ option.title }} </span>
              </base-checkbox>
            </div>
            <!-- <div class="col-lg-12" v-if="checkboxSelect.length">
              <hr class="mt-3 mb-4" />
              <label class="form-control-label">
                Alternativa(s) correta(s)
              </label>
              <p
                v-for="(option, oIndex) in modalView.question.options"
                :key="oIndex"
              >
                <i class="fas fa-angle-right mr-1"></i>
                {{
                  modalView.question.right_answer[oIndex] === true
                    ? option.title
                    : ""
                }}
              </p>
            </div> -->
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalView.show = false"
        >
          Voltar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Container, Draggable } from "vue-smooth-dnd";

export default {
  name: "avaliacao-form",
  components: {
    Container,
    Draggable,
  },
  props: {
    material: Object,
  },
  data() {
    return {
      model: {
        questions: {
          title: "",
          type: "",
          description: "",
          right_answer: [],
          options: [],
          showDetails: true,
        },
        option: {
          title: "",
        },
      },
      questionRequiredFields: ["title", "type"],
      modalView: {
        show: false,
        question: "",
        index: "",
        radioSelect: [],
        checkboxSelect: [],
      },
      materialTypes: [
        {
          type: "video",
          name: "Vídeo do YouTube",
        },
        { type: "pdf", name: "PDF" },
        { type: "link", name: "Link externo" },
        { type: "text", name: "Texto" },
        { type: "test", name: "Avaliação" },
      ],
      questionTypes: [
        {
          type: "radiobox",
          name: "Múltipla escolha",
        },
        {
          type: "checkbox",
          name: "Caixas de seleção",
        },
        {
          type: "text",
          name: "Texto",
        },
      ],
      error: "",
      editorEdittable: {
        placeholder: "Escreva o texto aqui..",
      },
    };
  },
  methods: {
    handleAddQuestions() {
      this.material.evaluation.push(Object.assign({}, this.model.questions));
      this.model.questions.title = "";
      this.model.questions.type = "";
      this.model.questions.description = "";
      this.model.questions.right_answer = [];
      this.model.questions.options = [];
    },
    handleRemoveQuestions(index) {
      this.material.evaluation.splice(index, 1);
    },
    handleAddOptions() {
      this.model.questions.options.push(Object.assign({}, this.model.option));
      this.model.option.title = "";
    },
    handleRemoveOptions(index) {
      this.model.questions.options.splice(index, 1);
    },
    handleOpenModalView(content, index) {
      this.modalView.question = content;
      this.modalView.index = index;
      this.modalView.radioSelect = [];
      this.modalView.checkboxSelect = [];
      this.modalView.show = true;
    },
    onDropOption(dropResult) {
      const { removedIndex, addedIndex } = dropResult;
      var opcoes = this.model.questions.options;
      let draggingMaterial = this.model.questions.options[removedIndex];
      if (removedIndex === addedIndex) return;
      if (removedIndex !== null) {
        opcoes.splice(removedIndex, 1);
      }
      if (addedIndex !== null) {
        opcoes.splice(addedIndex, 0, draggingMaterial);
      }
    },
    onDropQuestion(dropResult) {
      const { removedIndex, addedIndex } = dropResult;
      var questoes = this.material.evaluation;
      let draggingMaterial = this.material.evaluation[removedIndex];
      if (removedIndex === addedIndex) return;
      if (removedIndex !== null) {
        questoes.splice(removedIndex, 1);
      }
      if (addedIndex !== null) {
        questoes.splice(addedIndex, 0, draggingMaterial);
      }
    },
    truncate(text, stop = 30, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
  },
  computed: {
    isValidQuestion() {
      const question = this.model.questions;
      for (const key of this.questionRequiredFields) {
        if (question[key] === "") return false;
      }
      if (
        (this.model.questions.type === "radiobox" ||
          this.model.questions.type === "checkbox") &&
        !this.model.questions.options.length
      )
        return false;
      return true;
    },
  },
};
</script>
<style scoped>
.radiobox {
  background: #fff;
  color: #525f7f;
  padding: 1rem;
  border-radius: 5px;
  margin: 1rem 0 1rem 0;
}

.new_question {
  border: 4px solid rgba(85, 51, 255, 0.4);
}

.cursor {
  cursor: pointer;
}
</style>
